import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_dispatch_details: { message: "idle" },
};

export const retrieve_tenant_dispatch_details_Slice = createSlice({
 name: "retrieve_tenant_dispatch_details",
 initialState,
 reducers: {
  success_retrieve_tenant_dispatch_details: (state, action) => {
   state.retrieve_tenant_dispatch_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_dispatch_details: (state, action) => {
   state.retrieve_tenant_dispatch_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_dispatch_details: (state) => {
   state.retrieve_tenant_dispatch_details = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_dispatch_details: (state) => {
   state.retrieve_tenant_dispatch_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_dispatch_details, fail_retrieve_tenant_dispatch_details, reset_retrieve_tenant_dispatch_details, loading_retrieve_tenant_dispatch_details } = retrieve_tenant_dispatch_details_Slice.actions;

export default retrieve_tenant_dispatch_details_Slice.reducer;